export default __webpack_public_path__ + "resources/icons/n312-39e6.png";